import * as React from "react";
import type { TenantTagSetsOrCustomFieldsProps } from "~/areas/library/components/TenantTagSets/TenantTagSetsOrCustomFields";
import { TenantTagSetsOrCustomFields } from "~/areas/library/components/TenantTagSets/TenantTagSetsOrCustomFields";
type CustomFieldsPageProps = TenantTagSetsOrCustomFieldsProps;
export function CustomFieldsPage({ spaceId, queryParams, setQueryParams, loaderData }: CustomFieldsPageProps) {
    return <TenantTagSetsOrCustomFields spaceId={spaceId} queryParams={queryParams} setQueryParams={setQueryParams} loaderData={loaderData}/>;
}
